import rootExtractor from "@Dataset/rootExtractor";
import determineScreenWidth from "@Reducers/functions/determineScreenWidth";
import intToBool from "@Number/intToBool";
import getMainCompanyTransportType from "@Tabs/functions/getCompanyMainTransportType";
import parseExperiments from "@Features/experiments/functions/parseExperiments";
import PageSliceStateType from "@/types/pageSlice/PageSliceState.type";

const searchParams = new URLSearchParams(window.location.search);
const noHeader = searchParams.get('no_header') === "1"
const translations = JSON.parse(rootExtractor('translations'));
const companyStore = JSON.parse(rootExtractor('companyStore'));

export const pageSliceInitialState: PageSliceStateType = {
    locale: window.currentLocale || rootExtractor('locale'),
    activeLanguages: JSON.parse(window.activeLanguages),
    siteUrl: rootExtractor('siteUrl') || window.location.host,
    gbbUrl: rootExtractor('gbbUrl') ?? 'https://getbybus.com',
    gbtUrl: rootExtractor('gbtUrl') ?? 'https://getbytransfer.com',
    noHeader,
    ...determineScreenWidth(),
    isCompanyStore: intToBool(rootExtractor('isCompanyStore')),
    companyStore,
    companyMainTransportType: getMainCompanyTransportType(companyStore),
    translations,
    adminAssetsBaseUrl: rootExtractor('adminAssetsBase'),
    assetsBaseUrl: rootExtractor('assetsBase'),
    activeBlogLanguages: rootExtractor('activeBlogLanguages', true),
    langSpritePositions: rootExtractor('langSpritePositions', true),
    urlsObject: rootExtractor('urlsObject', true),
    urlsForHeaderMenu: rootExtractor('urlsForHeaderMenu', true),
    footerUrls: rootExtractor('footerUrls', true),
    myProfileRoutes: rootExtractor('myProfileRoutes', true),
    sidebar: rootExtractor('sidebar'),
    activePopup: false,
    activeStickyContainerHeight: 0,
    homepageData: rootExtractor('homepageData', true),
    eventToken: rootExtractor('tokenBawBi'),
    bawApiUrl: rootExtractor('bawApiUrl'),
    alwaysDispatchTrackingEvents: JSON.parse(rootExtractor('alwaysDispatchTrackingEvents')),
    experimentsArray: parseExperiments(rootExtractor('abExperiments')),
    experiments: rootExtractor('abExperiments'),
    dualPriceHrkEurConversionRate: rootExtractor('dualPriceHrkEurConversionRate'),
    isDualPriceRequirementActive: JSON.parse(rootExtractor('isDualPriceRequirementActive')),
    supportedCurrencies: Object.values(rootExtractor('supportedCurrencies', true)),
    sameTabRedirectProviders: Object.values(rootExtractor('sameTabRedirectProviders', true)),
    rentABusRoutePaths: JSON.parse(rootExtractor('rentABusRoutes')),
    experimentsJson: JSON.parse(rootExtractor('experimentsJson')),
    enabledClientsideFeatures: JSON.parse(rootExtractor('enabledClientsideFeatures')),
    is404Page: false,
    headerBackgroundImageRgbPixelData: [],
    error: undefined,
}